export default {
      id: "Icon--shuffle-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--shuffle",
      toString: function () {
        return this.url;
      }
    }